import { render } from "./PantryImageSelectItem.vue?vue&type=template&id=581f8268&ts=true"
import script from "./PantryImageSelectItem.vue?vue&type=script&lang=ts"
export * from "./PantryImageSelectItem.vue?vue&type=script&lang=ts"

import "./PantryImageSelectItem.vue?vue&type=style&index=0&id=581f8268&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__